<mat-dialog-content class="p-4">
    <h3 style="font-size: 25px;">Search by Filter</h3>
    <form [formGroup]="form">
        <div class="row mt-3">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Provider</mat-label>
                    <mat-select multiple formControlName="provider" (selectionChange)="onProviderChange($event)">
                        <mat-select-trigger>
                            <mat-chip-set *ngIf="form.controls.provider.value?.length">
                                <mat-chip style="background: #F7F2FF;" *ngFor="let option of form.controls.provider.value" [removable]="true" (removed)="removeOption(option)">
                                    <span>{{ option }}</span>
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-set>
                            <span *ngIf="!form.controls.provider.value?.length">Select Provider...</span>
                        </mat-select-trigger>

                        <mat-option *ngFor="let provider of data?.providers" [value]="provider.providerName">
                            {{ provider.providerName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>CE Type</mat-label>
                    <mat-select multiple formControlName="ceType" (selectionChange)="onCETypeChange($event)">
                        <mat-select-trigger>
                            <mat-chip-set *ngIf="form.controls.ceType.value?.length">
                                <mat-chip style="background: #F7F2FF;" *ngFor="let option of form.controls.ceType.value" [removable]="true" (removed)="removeOptionCEType(option)">
                                    <span>{{ option }}</span>
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-set>
                            <span *ngIf="!form.controls.ceType.value?.length">Select CE Type...</span>
                        </mat-select-trigger>

                        <mat-option *ngFor="let ceType of data?.ceTypes" [value]="ceType.parameterValue">
                            {{ ceType.parameterLabel }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Attendance Type</mat-label>
                    <mat-select formControlName="attendanceType" (selectionChange)="onAttendanceTypeChange($event)">
                        <mat-option *ngFor="let attendanceType of data?.attendanceTypes" [value]="attendanceType.parameterValue">
                            {{ attendanceType.parameterLabel }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Date</mat-label>
                    <mat-select formControlName="dateRange">
                        <mat-option *ngFor="let option of optionDateRange" [value]="option.parameterValue">
                            {{ option.parameterLabel }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="p-4 justify-content-end">
    <button mat-raised-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="warn" (click)="resetForm()">Reset</button>
    <button mat-raised-button color="primary" (click)="applyFilter()">Apply</button>
</mat-dialog-actions>